<template>
  <div class="relative">
    <button @click.stop="$emit('toggle')"
      class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
      </svg>
      {{ I18N.application.index.export }}
    </button>

    <div v-if="open" @click.stop
      class="absolute right-0 z-30 mt-1 w-44 bg-white dark:bg-[#1C2128] rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 py-1 text-sm divide-y divide-gray-100 dark:divide-gray-700">
      <a v-for="link in links" :key="link.type" :href="link.href"
        class="block px-3.5 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
        {{ link.label }} (xlsx)
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useConstants } from 'composables/useConstants.js'

const props = defineProps({
  eventId: { type: [String, Number], required: true },
  open: { type: Boolean, default: false },
})
defineEmits(['toggle'])

const { I18N } = useConstants()

function exportUrl(type) {
  const path = type === 'all' ? '/exports/events/bookings.xlsx' : `/exports/events/bookings/${type}.xlsx`
  return `${path}?requester=events_show&id=${props.eventId}`
}

const links = computed(() => [
  { type: 'upcoming', label: I18N.application.index.upcoming, href: exportUrl('upcoming') },
  { type: 'past', label: I18N.application.index.past, href: exportUrl('past') },
  { type: 'canceled', label: I18N.application.index.canceled, href: exportUrl('canceled') },
  { type: 'archived', label: I18N.application.index.archived, href: exportUrl('archived') },
  { type: 'all', label: I18N.application.index.all_bookings, href: exportUrl('all') },
])
</script>
